import moment from "@/utils/moment";
import accountHelper from "@/utils/helpers/account";

const STATES = {
  created: {
    icon: "/static/icon_order_status_alert.svg",
    name: "criado",
    color: "primary"
  },
  requested_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    name: "criando dependências",
    color: "warning"
  },
  created_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    name: "aguardando pagamento",
    color: "warning"
  },
  payment_requested: {
    icon: "/static/icon_order_status_alert.svg",
    name: "pagamento solicitado",
    color: "warning"
  },
  waiting_payment: {
    icon: "/static/icon_order_status_alert.svg",
    name: "aguardando pagamento",
    color: "warning"
  },
  paid: {
    icon: "/static/icon_order_status_ok.svg",
    name: "pago",
    color: "success"
  },
  active: {
    icon: "/static/icon_order_status_ok.svg",
    name: "ativo",
    color: "success"
  },
  ended: {
    icon: "/static/icon_order_status_ok.svg",
    name: "finalizado",
    color: "success"
  },
  cancelled: {
    icon: "/static/icon_order_status_canceled.svg",
    name: "cancelado",
    color: "disabled"
  }
};

const PAYMENT_STATES = [
  "created_on_gateway",
  "payment_requested",
  "waiting_payment"
];

const LAST_PAYMENT_DAY = 12;

const getState = state => STATES[state] || null;

const isInPaymentStatus = status => PAYMENT_STATES.includes(status);

const isBeforeLastPaymentDay = startsAt =>
  moment().startOf("day") <
  moment(startsAt)
    .date(LAST_PAYMENT_DAY)
    .startOf("day");

const isAbleToPay = cycle =>
  isBeforeLastPaymentDay(cycle.starts_at) && isInPaymentStatus(cycle.status);

const filterCycles = (cycles, field, values) =>
  cycles.filter(cycle => !values.includes(cycle[field]));

const sortByStartsAt = cycles =>
  cycles.sort((a, b) => moment(b.starts_at) - moment(a.starts_at));

const noticeOfPaymentTermLoss = account =>
  `Oi, sou usuário do app Donamaid, ${accountHelper.fullName(account)} - ${
    account.email
  }. Perdi o prazo para o pagamento do ciclo de assinatura e gostaria de retomá-la.`;

export default {
  getState,
  isAbleToPay,
  filterCycles,
  sortByStartsAt,
  isInPaymentStatus,
  isBeforeLastPaymentDay,
  noticeOfPaymentTermLoss
};



// WEBPACK FOOTER //
// ./src/utils/states/cycle.js